import { combineReducers } from '@ngrx/store';

import { 
  homeDataReducer as homeData
} from '@home/store/reducers/home-data.reducer';
import { UiHomeRootReducer as ui } from './ux';
import { userHistoryListReducer as userHistory} from '@home/store/reducers/user-history.reducer';

export const homeRootReducer = combineReducers({
  homeData,
  userHistory,
  ui
});
